module.exports = __webpack_public_path__ + "static/media/sample8.f73028f3.jpg";